import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.MIXPANNEL_TRACKER_TOKEN;

mixpanel.init(MIXPANEL_TOKEN as string, {
  debug: true,
  track_pageview: true,
  persistence: 'localStorage',
});